import React from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Grid, 
  Card, 
  CardContent, 
  Chip, 
  List, 
  ListItem, 
  ListItemText,
  Link,
  useTheme,
 
} from '@mui/material';
import { FadeInSection } from '../Animations/FadeInAnimation';

const GameDeveloperPortfolio: React.FC = () => {
  const theme = useTheme();
  
  return (
    <Box component="main">
      {/* Header */}
     
      
      {/* Summary */}
      <FadeInSection delay={0.2}>
        
        <Box sx={{ py: 8, bgcolor: `rgb(30, 41, 59)` }}>
          <Container>
            <Typography 
              variant="h4" 
              component="h2" 
              align="center" 
              gutterBottom
              sx={{ 
                mb: 5,
                mt:'5px', 
                position: 'relative',
                pb: 2,
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: 0,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: 100,
                  height: 3,
                  bgcolor: theme.palette.secondary.main
                }
              }}
            >
              Profile Summary
            </Typography>
            <Box maxWidth={900} margin="0 auto">
              <Typography variant="body1" align="center" sx={{lineHeight: 1.8, fontSize: '1.1rem' }}>
                With over 5+ years of experience as a Full Stack Developer with specialized expertise in game development, 
                We bring a robust technical skill set that includes Django, Python, Node.js, JavaScript, TypeScript, 
                React.js, Three.js, WebGL, Socket.io, MongoDB, PostgreSQL, Docker, AWS, and Unity WebGL export. 
                We have successfully delivered multiple browser-based games with immersive gameplay, multiplayer 
                functionality, and optimized performance. My experience combines the precision of enterprise 
                development with the creativity and optimization required for engaging game experiences.
              </Typography>
            </Box>
          </Container>
        </Box>
      </FadeInSection>

      {/* Game Projects */}
      <FadeInSection delay={0.4}>
        <Box sx={{ py: 8, bgcolor: `rgb(30, 41, 59)` }}>
          <Container>
            <Typography 
              variant="h4" 
              component="h2" 
              align="center" 
              gutterBottom
              sx={{ 
                mb: 5, 
                position: 'relative',
                pb: 2,
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: 0,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: 100,
                  height: 3,
                  bgcolor: theme.palette.secondary.main
                }
              }}
            >
              Game Development Portfolio
            </Typography>
            <Grid container spacing={3}>
              {/* Project 1 */}
              <Grid item xs={12} md={6} lg={4}>
                <Card 
                  sx={{ 
                    height: '100%', 
                    borderRadius: 4,
                    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-10px)',
                      boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)'
                    }
                  }}
                >
                  <CardContent sx={{ 
                    p: 4, 
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                    <Typography 
                      variant="h6" 
                      component="h3" 
                      gutterBottom
                      color="primary"
                    >
                      RaceDash India
                    </Typography>
                    <Typography 
                      variant="subtitle2" 
                      color="secondary"
                      fontWeight="bold"
                      sx={{ mb: 2 }}
                    >
                      2024-2025
                    </Typography>
                    <Typography 
                      variant="body2" 
                      sx={{ mb: 3, flexGrow: 1 }}
                    >
                      WebGL-based racing game with real-time multiplayer capabilities, advanced data synchronization system using Socket.io and Node.js, and physics-based vehicle movement systems.
                    </Typography>
                    <Box 
                      sx={{ 
                        display: 'flex', 
                        flexWrap: 'wrap', 
                        gap: 1,
                        mt: 'auto'
                      }}
                    >
                      <Chip label="WebGL" size="small" />
                      <Chip label="Socket.io" size="small" />
                      <Chip label="Three.js" size="small" />
                      <Chip label="Node.js" size="small" />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Project 2 */}
              <Grid item xs={12} md={6} lg={4}>
                <Card 
                  sx={{ 
                    height: '100%', 
                    borderRadius: 4,
                    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-10px)',
                      boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)'
                    }
                  }}
                >
                  <CardContent sx={{ 
                    p: 4, 
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                    <Typography 
                      variant="h6" 
                      component="h3" 
                      gutterBottom
                      color="primary"
                    >
                      TruckJam Highways
                    </Typography>
                    <Typography 
                      variant="subtitle2" 
                      color="secondary"
                      fontWeight="bold"
                      sx={{ mb: 2 }}
                    >
                      2022-2024
                    </Typography>
                    <Typography 
                      variant="body2" 
                      sx={{ mb: 3, flexGrow: 1 }}
                    >
                      Mobile-optimized browser game supporting 5,000+ concurrent players with advanced replay system and custom vehicle physics engine optimized for mobile browsers (60fps).
                    </Typography>
                    <Box 
                      sx={{ 
                        display: 'flex', 
                        flexWrap: 'wrap', 
                        gap: 1,
                        mt: 'auto'
                      }}
                    >
                      <Chip label="Canvas API" size="small" />
                      <Chip label="JavaScript" size="small" />
                      <Chip label="Mobile-first" size="small" />
                      <Chip label="Physics Engine" size="small" />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Project 3 */}
              <Grid item xs={12} md={6} lg={4}>
                <Card 
                  sx={{ 
                    height: '100%', 
                    borderRadius: 4,
                    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-10px)',
                      boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)'
                    }
                  }}
                >
                  <CardContent sx={{ 
                    p: 4, 
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                    <Typography 
                      variant="h6" 
                      component="h3" 
                      gutterBottom
                      color="primary"
                    >
                      BoardRider Fusion
                    </Typography>
                    <Typography 
                      variant="subtitle2" 
                      color="secondary"
                      fontWeight="bold"
                      sx={{ mb: 2 }}
                    >
                      2020-2021
                    </Typography>
                    <Typography 
                      variant="body2" 
                      sx={{ mb: 3, flexGrow: 1 }}
                    >
                      Full-stack development of a gamified board game racing hybrid with cross-platform gameplay using HTML5 Canvas, JavaScript and responsive design.
                    </Typography>
                    <Box 
                      sx={{ 
                        display: 'flex', 
                        flexWrap: 'wrap', 
                        gap: 1,
                        mt: 'auto'
                      }}
                    >
                      <Chip label="HTML5 Canvas" size="small" />
                      <Chip label="LocalStorage" size="small" />
                      <Chip label="IndexedDB" size="small" />
                      <Chip label="Responsive" size="small" />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Project 4 */}
              <Grid item xs={12} md={6} lg={4}>
                <Card 
                  sx={{ 
                    height: '100%', 
                    borderRadius: 4,
                    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-10px)',
                      boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)'
                    }
                  }}
                >
                  <CardContent sx={{ 
                    p: 4, 
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                    <Typography 
                      variant="h6" 
                      component="h3" 
                      gutterBottom
                      color="primary"
                    >
                      SpeedLane Rivals
                    </Typography>
                    <Typography 
                      variant="subtitle2" 
                      color="secondary"
                      fontWeight="bold"
                      sx={{ mb: 2 }}
                    >
                      Multiplayer Racing Simulation
                    </Typography>
                    <Typography 
                      variant="body2" 
                      sx={{ mb: 3, flexGrow: 1 }}
                    >
                      High-performance racing game supporting up to 12 simultaneous players with innovative replay system and voice chat during multiplayer sessions via WebRTC.
                    </Typography>
                    <Box 
                      sx={{ 
                        display: 'flex', 
                        flexWrap: 'wrap', 
                        gap: 1,
                        mt: 'auto'
                      }}
                    >
                      <Chip label="Three.js" size="small" />
                      <Chip label="WebGL" size="small" />
                      <Chip label="Node.js" size="small" />
                      <Chip label="MongoDB" size="small" />
                      <Chip label="AWS" size="small" />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>

              {/* Project 5 */}
              <Grid item xs={12} md={6} lg={4}>
                <Card 
                  sx={{ 
                    height: '100%', 
                    borderRadius: 4,
                    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.05)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'translateY(-10px)',
                      boxShadow: '0 15px 30px rgba(0, 0, 0, 0.1)'
                    }
                  }}
                >
                  <CardContent sx={{ 
                    p: 4, 
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column'
                  }}>
                    <Typography 
                      variant="h6" 
                      component="h3" 
                      gutterBottom
                      color="primary"
                    >
                      DriftEdge Racing
                    </Typography>
                    <Typography 
                      variant="subtitle2" 
                      color="secondary"
                      fontWeight="bold"
                      sx={{ mb: 2 }}
                    >
                      Retro-Styled Multiplayer Racing Game
                    </Typography>
                    <Typography 
                      variant="body2" 
                      color="text.secondary"
                      sx={{ mb: 3, flexGrow: 1 }}
                    >
                      Arcade-style racing game with pixel art aesthetics and modern gameplay, featuring custom 2D physics engine and track editor allowing players to design and share custom race tracks.
                    </Typography>
                    <Box 
                      sx={{ 
                        display: 'flex', 
                        flexWrap: 'wrap', 
                        gap: 1,
                        mt: 'auto'
                      }}
                    >
                      <Chip label="Phaser.js" size="small" />
                      <Chip label="WebGL" size="small" />
                      <Chip label="Express.js" size="small" />
                      <Chip label="PostgreSQL" size="small" />
                      <Chip label="Firebase" size="small" />
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Container>
        </Box>
      </FadeInSection>

      {/* Skills */}
      <FadeInSection delay={0.6}>
      <Box sx={{ py: 8, bgcolor: 'rgb(30, 41, 59)' }}>
        <Container>
          <Typography 
            variant="h4" 
            component="h2" 
            align="center" 
            color="text.primary"
            gutterBottom
            sx={{ 
              mb: 5, 
              position: 'relative',
              pb: 2,
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: 0,
                left: '50%',
                transform: 'translateX(-50%)',
                width: 100,
                height: 3,
                bgcolor: theme.palette.secondary.main
              }
            }}
          >
            Specialized Game Development Skills
          </Typography>
          <Grid container spacing={4}>
            {/* Skill Category 1 */}
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <Typography 
                  variant="h6" 
                  component="h3" 
                  color="primary"
                  sx={{ 
                    mb: 2, 
                    pb: 1, 
                    borderBottom: `2px solid ${theme.palette.secondary.main}` 
                  }}
                >
                  Game Engines & Frameworks
                </Typography>
                <List>
                  {['Three.js', 'Babylon.js', 'Phaser.js', 'PixiJS', 'Unity (WebGL export)'].map((skill) => (
                    <ListItem key={skill} sx={{ py: 0.5, display: 'flex', alignItems: 'center' }}>
                      <Box component="span" sx={{ color: theme.palette.secondary.main, mr: 1 }}>▹</Box>
                      <Typography color="text.primary">{skill}</Typography>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Grid>

            {/* Skill Category 2 */}
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <Typography 
                  variant="h6" 
                  component="h3" 
                  color="primary"
                  sx={{ 
                    mb: 2, 
                    pb: 1, 
                    borderBottom: `2px solid ${theme.palette.secondary.main}` 
                  }}
                >
                  Graphics & Rendering
                </Typography>
                <List>
                  {['WebGL', 'Canvas API', 'SVG', 'GLSL shaders', '3D modeling integration'].map((skill) => (
                    <ListItem key={skill} sx={{ py: 0.5, display: 'flex', alignItems: 'center' }}>
                      <Box component="span" sx={{ color: theme.palette.secondary.main, mr: 1 }}>▹</Box>
                      <Typography color="text.primary">{skill}</Typography>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Grid>

            {/* Skill Category 3 */}
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <Typography 
                  variant="h6" 
                  component="h3" 
                  color="primary"
                  sx={{ 
                    mb: 2, 
                    pb: 1, 
                    borderBottom: `2px solid ${theme.palette.secondary.main}` 
                  }}
                >
                  Physics & Gameplay
                </Typography>
                <List>
                  {['Custom physics engines', 'Collision detection', 'Vehicle dynamics'].map((skill) => (
                    <ListItem key={skill} sx={{ py: 0.5, display: 'flex', alignItems: 'center' }}>
                      <Box component="span" sx={{ color: theme.palette.secondary.main, mr: 1 }}>▹</Box>
                      <Typography color="text.primary">{skill}</Typography>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Grid>

            {/* Skill Category 4 */}
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <Typography 
                  variant="h6" 
                  component="h3" 
                  color="primary"
                  sx={{ 
                    mb: 2, 
                    pb: 1, 
                    borderBottom: `2px solid ${theme.palette.secondary.main}` 
                  }}
                >
                  Multiplayer Systems
                </Typography>
                <List>
                  {['Socket.io', 'WebSockets', 'WebRTC', 'Firebase Realtime Database'].map((skill) => (
                    <ListItem key={skill} sx={{ py: 0.5, display: 'flex', alignItems: 'center' }}>
                      <Box component="span" sx={{ color: theme.palette.secondary.main, mr: 1 }}>▹</Box>
                      <Typography color="text.primary">{skill}</Typography>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Grid>

            {/* Skill Category 5 */}
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <Typography 
                  variant="h6" 
                  component="h3" 
                  color="primary"
                  sx={{ 
                    mb: 2, 
                    pb: 1, 
                    borderBottom: `2px solid ${theme.palette.secondary.main}` 
                  }}
                >
                  Performance Optimization
                </Typography>
                <List>
                  {['Asset compression', 'Shader optimization', 'Memory management'].map((skill) => (
                    <ListItem key={skill} sx={{ py: 0.5, display: 'flex', alignItems: 'center' }}>
                      <Box component="span" sx={{ color: theme.palette.secondary.main, mr: 1 }}>▹</Box>
                      <Typography color="text.primary">{skill}</Typography>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Grid>

            {/* Skill Category 6 */}
            <Grid item xs={12} sm={6} md={4}>
              <Box>
                <Typography 
                  variant="h6" 
                  component="h3" 
                  color="primary"
                  sx={{ 
                    mb: 2, 
                    pb: 1, 
                    borderBottom: `2px solid ${theme.palette.secondary.main}` 
                  }}
                >
                  Monetization & Analytics
                </Typography>
                <List>
                  {['In-app purchases', 'Ad integration', 'Progression systems', 'Custom event tracking', 'A/B testing'].map((skill) => (
                    <ListItem key={skill} sx={{ py: 0.5, display: 'flex', alignItems: 'center' }}>
                      <Box component="span" sx={{ color: theme.palette.secondary.main, mr: 1 }}>▹</Box>
                      <Typography color="text.primary">{skill}</Typography>
                    </ListItem>
                  ))}
                </List>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </FadeInSection>

      {/* Why Choose Me */}
      <FadeInSection delay={0.8}>
        <Box sx={{ py: 8, bgcolor: `rgb(30, 41, 59)` }}>
          <Container>
            <Typography 
              variant="h4" 
              component="h2" 
              align="center" 
              color="text.primary"
              gutterBottom
              sx={{ 
                mb: 5, 
                position: 'relative',
                pb: 2,
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  bottom: 0,
                  left: '50%',
                  transform: 'translateX(-50%)',
                  width: 100,
                  height: 3,
                  bgcolor: theme.palette.secondary.main
                }
              }}
            >
              Why we are Ideal For Game Projects
            </Typography>
            <Box maxWidth={900} margin="0 auto">
              <Typography variant="body1" paragraph color="text.primary">
                Our specialized experience in game development enables me to create engaging, 
                high-performance games that work seamlessly across devices.We excel at optimizing graphics 
                rendering, implementing smooth multiplayer experiences, and creating intuitive user 
                interfaces that enhance gameplay.
              </Typography>
              <Typography variant="body1" paragraph color="text.primary">
                Our technical background in both frontend and backend development allows me to build 
                complete gaming solutions from the ground up, with particular strength in:
              </Typography>
              <List>
                {[
                  'Creating optimized 3D/2D rendering for browser environments',
                  'Implementing real-time multiplayer mechanics with minimal latency',
                  'Designing responsive interfaces that work on both desktop and mobile browsers',
                  'Building scalable backend architectures that support thousands of concurrent players'
                ].map((item, index) => (
                  <ListItem key={index} sx={{ py: 1 }}>
                    <ListItemText 
                      primary={item} 
                      primaryTypographyProps={{ color: 'text.primary' }}
                      sx={{ 
                        pl: 3,
                        position: 'relative',
                        '&::before': {
                          content: '"✓"',
                          color: theme.palette.secondary.main,
                          position: 'absolute',
                          left: 0,
                          fontWeight: 'bold'
                        }
                      }}
                    />
                  </ListItem>
                ))}
              </List>
            </Box>
          </Container>
        </Box>
      </FadeInSection>

     
      {/* Footer */}
      <Box sx={{ 
        py: 7, 
        pb: 3, 
        bgcolor: theme.palette.primary.dark, 
        color: '#ffffff',
        textAlign: 'center' 
      }}>
        <Container>
          <Box maxWidth={600} margin="0 auto">
            <Box sx={{ mb: 4 }}>
              <Typography variant="body1" paragraph color="white">
                Let's discuss how we can bring your gaming vision to life.
              </Typography>
              <Typography variant="body1" color="white">
                Contact us at <Link href="mailto:support@qixbi.com" sx={{ color: theme.palette.secondary.main, fontWeight: 'bold', textDecoration: 'none' }}>support@qixbi.com</Link> 
              </Typography>
            </Box>
            
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default GameDeveloperPortfolio;